/**
 * Prevents FOIT of custom webfonts in favour of FOUT.
 *
 * @summary Webfont loader.
 * @requires FontFaceObserver
 */

import FontFaceObserver from 'fontfaceobserver/fontfaceobserver.standalone';

const fonts = [
	new FontFaceObserver( 'Open Sans', { weight: 300 }).load(),
	new FontFaceObserver( 'Open Sans', { weight: 400 }).load(),
	new FontFaceObserver( 'Open Sans', { weight: 700 }).load()
];

Promise.all( fonts )
	.then( () => {
		document.body.classList.add( 't-open-sans' );
	});



// WEBPACK FOOTER //
// ./src/js/font-load.js